import { useQuery } from '@gogame/query';
import { useScreenState } from '@gogame/screens';

import { loadChart } from 'scenes/Trackers/Tracker/sources/trackerChart';

import { chart } from './queryKeyFactory';

export const useTrackerChart = ({ enabled, ...params }, callback) => {
  const screenState = useScreenState();

  return useQuery(
    chart({ ...params, forceReloadId: screenState.forceReloadId }),
    (_, { signal }) => {
      signal.onabort = () => {
        window.dataLayer.push({
          event: 'requestCanceled',
          event_action: 'Chart',
          event_value: 1,
        });
      };
      return loadChart(params, { signal });
    },
    {
      enabled,
      onSuccess: callback,
      keepPreviousData: enabled,
      staleTime: 1000 * 60 * 5,
      cacheTime: 1000 * 60 * 5,
    }
  );
};
